import { GraphQLResult, graphqlOperation } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import {
  Announce,
  GetAnnounceQuery,
  GetAnnounceQueryVariables,
  ListAnnouncesByYmQuery,
  ListAnnouncesByYmQueryVariables
} from "graphql/API";
import {
  getAnnounce as getAnnounceQuery,
  listAnnouncesByYm as listAnnouncesByYmQuery
} from "graphql/queries";

export const getAnnounce = async (
  id: string | undefined
): Promise<GetAnnounceQuery | undefined> => {
  if (id) {
    const client = generateClient();
    const announceData = (await client.graphql({
      ...graphqlOperation(getAnnounceQuery, {
        id
      } as GetAnnounceQueryVariables),
      authMode: "userPool"
    })) as GraphQLResult<GetAnnounceQuery>;

    return announceData.data;
  }
};

export const listAnnouncesByYm = async (yms: string[]) => {
  const announces: Announce[] = [];

  const variablesList: ListAnnouncesByYmQueryVariables[] = yms.map((ym) => ({
    ym,
    limit: 1000,
    nextToken: null
  }));

  for (const variables of variablesList) {
    const client = generateClient();

    while (true) {
      if (variables.nextToken === null) {
        delete variables.nextToken;
      }

      const res = (await client.graphql({
        ...graphqlOperation(listAnnouncesByYmQuery, variables),
        authMode: "userPool"
      })) as GraphQLResult<ListAnnouncesByYmQuery>;

      if (res.data?.listAnnouncesByYm?.items) {
        announces.push(
          ...((res.data?.listAnnouncesByYm.items ?? [])
            .filter((x) => x)
            .map((x) => ({ ...x, __typename: "Announce" })) as Announce[])
        );
      }

      variables.nextToken = res.data?.listAnnouncesByYm?.nextToken || null;

      if (variables.nextToken === null) {
        break;
      }
    }
  }

  announces.sort((a, b) => {
    const order = (a.createdAt || "").localeCompare(b.createdAt || "");

    return order * -1;
  });

  return announces;
};
